import React from 'react';
import { Button, Typography } from '@mui/material';
import { apiFetch } from '../../toolympus/api/core';
import { useActionWithConfirmation } from '../../toolympus/api/useAction';
import { SnapshotsContainer } from '../../toolympus/components/Snapshots/SnapshotsContainer';

export const ArchivesManagement = () => {
    const cleanup = () => apiFetch("/api/snapshot/clean", "post");

    const cleanupAction = useActionWithConfirmation(cleanup, {
        confirmationText: "clean",
        confirmationHint: <>
            <Typography key="l1">The database will be wiped out for a new iteration of the Academy.</Typography>
            <Typography key="l2">This action is ireversible (as in "we totally can't undo that"). To proceed please enter 'clean' below and press the button.</Typography>
            </>,
        title: "Clean the database",
        confirmationLabel: "I understand the consequences, clean it",

    });

    return <SnapshotsContainer
        apiPath="/api/snapshot"
        extraActions={<Button color="secondary" onClick={cleanupAction.run} disabled={!cleanupAction.canRun}>clean the database</Button>}
        />;
}
